import {
  SlInput
} from "./chunk.5AOJIJ4Q.js";

// src/components/input/input.ts
var input_default = SlInput;
SlInput.define("sl-input");

export {
  input_default
};
